module.exports = __webpack_public_path__ + "17_hair_black.418b9e2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/17_hair_black.png
// module id = BjT7
// module chunks = 0